import React from 'react';
import './index.css';

const NumberBadge = ({ number }) => {
    return <div className="item">{number}</div>;
};

export default NumberBadge;
